import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigationItems = [
    { name: 'Home', path: '/homepage', icon: 'Home' },
    { name: 'About', path: '/about', icon: 'Users' },
    { name: 'Services', path: '/services', icon: 'Code' },
    { name: 'Portfolio', path: '/portfolio', icon: 'Briefcase' },
    { name: 'Blog', path: '/blog', icon: 'FileText' }
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const Logo3D = () => (
    <div className="relative group">
      <div className="flex items-center space-x-3 transform-3d perspective-1000">
        <div className="relative">
          {/* <div className="w-10 h-10 bg-gradient-to-br from-accent to-accent/70 rounded-lg shadow-accent transform rotate-12 group-hover:rotate-45 animation-smooth"> */}
            {/* <div className="absolute inset-0 bg-primary/20 rounded-lg transform -rotate-12 group-hover:-rotate-45 animation-smooth"></div> */}
            {/* <div className="absolute inset-2 bg-accent rounded-md flex items-center justify-center"> */}
             <img src="/logo.png" alt="shutter-lifters" className='w-[50px] h-[50px]' />
              {/* <Icon name="Camera" size={16} color="var(--color-primary)" />
              insert logo here */}
            {/* </div> */}
          {/* </div> */}
        </div>
        <div className="font-bold text-xl text-foreground group-hover:text-accent animation-smooth">
          Shutter Lifters
        </div>
      </div>
    </div>
  );

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-background/95 backdrop-blur-md shadow-3d border-b border-border' 
        : 'bg-transparent'
    }`}>
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-6 lg:px-8">
          {/* Logo */}
          <Link to="/homepage" className="flex-shrink-0">
            <Logo3D />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`relative flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 group ${
                  isActivePath(item?.path)
                    ? 'text-accent bg-accent/10 shadow-accent'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                <Icon 
                  name={item?.icon} 
                  size={16} 
                  className={`transition-transform duration-300 group-hover:scale-110 ${
                    isActivePath(item?.path) ? 'text-accent' : ''
                  }`}
                />
                <span>{item?.name}</span>
                {isActivePath(item?.path) && (
                  <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-accent rounded-full"></div>
                )}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <Link to="/contact">
              <Button 
                variant="outline" 
                size="sm"
                iconName="MessageCircle"
                iconPosition="left"
                className="border-accent/30 text-accent "
              >
                Contact
              </Button>
            </Link>
            <Button 
              variant="default"
              size="sm"
              iconName="Rocket"
              iconPosition="left"
              className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-accent"
            >
              Start Project
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
            aria-label="Toggle mobile menu"
          >
            <Icon 
              name={isMobileMenuOpen ? "X" : "Menu"} 
              size={24}
              className="transition-transform duration-300"
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`lg:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen 
            ? 'max-h-96 opacity-100 border-b border-border' :'max-h-0 opacity-0'
        }`}>
          <div className="bg-background/95 backdrop-blur-md px-6 py-4 space-y-2">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 ${
                  isActivePath(item?.path)
                    ? 'text-accent bg-accent/10 shadow-accent'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                <Icon 
                  name={item?.icon} 
                  size={18} 
                  className={isActivePath(item?.path) ? 'text-accent' : ''}
                />
                <span>{item?.name}</span>
              </Link>
            ))}
            
            {/* Mobile CTAs */}
            <div className="pt-4 space-y-3 border-t border-border">
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                <Button 
                  variant="outline" 
                  size="sm"
                  fullWidth
                  iconName="MessageCircle"
                  iconPosition="left"
                  className="border-accent/30 text-accent hover:bg-accent/10 hover:border-accent"
                >
                  Contact Us
                </Button>
              </Link>
              <Button 
                variant="default"
                size="sm"
                fullWidth
                iconName="Rocket"
                iconPosition="left"
                className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-accent"
              >
                Start Your Project
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;